import React from 'react';
import PropTypes from 'prop-types';
import { balanceSummary, fullName, money, lessonTypeLabel, polishDate } from './clientPortalSelectors';

export function BillingSummary({ ledger, client }) {
  const balance = balanceSummary(ledger && ledger.balance);
  return (
    <section className="client-portal__card client-portal__billing">
      <h2>Rozliczenie płatnika</h2><p className="text-muted">Wszyscy uczniowie · <span>{fullName(client)}</span></p>
      {balance ? <><div className="client-portal__balance-label">{balance.label}</div><div className="client-portal__balance">{money(balance.amount)}</div></> : <p>Dane rozliczenia niedostępne</p>}
    </section>
  );
}
BillingSummary.propTypes = { ledger: PropTypes.object, client: PropTypes.object.isRequired };
BillingSummary.defaultProps = { ledger: null };

export function PackageCard({ item, lessonTypes }) {
  const balance = item.balance || {};
  const status = { awaitingPayment: 'Oczekuje na płatność', active: 'Aktywny', expired: 'Wygasł', depleted: 'Wykorzystany', cancelled: 'Anulowany' }[item.status] || item.status;
  const warnings = { awaitingPayment: 'Pakiet będzie aktywny po zaksięgowaniu płatności', endingSoon: 'Pakiet niedługo się skończy' };
  return (
    <article className="client-portal__package-card">
      <div><h3>{item.name}</h3><p className="text-muted">{lessonTypeLabel(item.classTypeId, lessonTypes)}</p></div>
      <p className="client-portal__status">{status}</p>
      {item.participationStrategy === 'shared_students' && <p>Pakiet współdzielony — licznik całego pakietu</p>}
      {(!Array.isArray(item.eligibleStudentIds) || !item.eligibleStudentIds.length) && <p>Pakiet płatnika — przypisanie do ucznia niedostępne</p>}
      <div className="client-portal__package-counts">
        <span>Dostępne: <strong>{balance.availableUnits == null ? '—' : balance.availableUnits}</strong></span>
        <span>Zarezerwowane: <strong>{balance.reservedUnits == null ? '—' : balance.reservedUnits}</strong></span>
        <span>Wykorzystane: <strong>{balance.consumedUnits == null ? '—' : balance.consumedUnits}</strong></span>
      </div>
      {item.validityEndDate && <p>Ważny do: {polishDate(item.validityEndDate)}</p>}
      {item.paymentDueDate && <p>Płatność do: {polishDate(item.paymentDueDate)}</p>}
      {(item.warnings || []).map(warning => <p className="client-portal__warning" key={warning}>{warnings[warning] || warning}</p>)}
    </article>
  );
}
PackageCard.propTypes = { item: PropTypes.object.isRequired, lessonTypes: PropTypes.array.isRequired };
export function AssociationNotice() { return <p className="client-portal__warning">Przypisanie części danych do ucznia jest niedostępne.</p>; }
